export default __webpack_public_path__ + "static/media/joytcp-6.9f46f58b.png";